export const GlobalGender = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
  UNKNOWN: 'unknown',
} as const

export type GlobalGender = typeof GlobalGender[keyof typeof GlobalGender]
